'use strict';


var fgPrimary = "33b533";

var fgPrimary_hover = "169116";

var fgSecondary = "3a3ab5";

var fgSecondary_hover = "4a4aed";

var fgTertiary = "189dd5";

var bgPrimary = "0e1e3b";

var bgPrimary_accent = "485d82";

var bgSecondary = "f1f1f1";

var textWhite = "f5f5f5";

var textBlack = "0e1e3b";

var danger = "dc3545";

exports.fgPrimary = fgPrimary;
exports.fgPrimary_hover = fgPrimary_hover;
exports.fgSecondary = fgSecondary;
exports.fgSecondary_hover = fgSecondary_hover;
exports.fgTertiary = fgTertiary;
exports.bgPrimary = bgPrimary;
exports.bgPrimary_accent = bgPrimary_accent;
exports.bgSecondary = bgSecondary;
exports.textWhite = textWhite;
exports.textBlack = textBlack;
exports.danger = danger;
/* No side effect */
